export default __webpack_public_path__ + "static/media/nolimit-mono.fc6802d1.svg";